export default __webpack_public_path__ + "10c5248184295ca86445fbaf15e57103.svg";